import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "building-main" */ '../pages/building/main');
})();
